import moment from "moment";

const createRangeDates = () => {
  const fromDate = moment().format("YYYY-MM-D");
  const toDate = moment().add(6, "months").format("YYYY-MM-D");
  return { fromDate, toDate };
};

export default createRangeDates;
